/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MeasuringPointOverview
 */
export interface MeasuringPointOverview {
  /**
   *
   * @type {string}
   * @memberof MeasuringPointOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {MeasuringPointOverviewEventTypeEnum}
   * @memberof MeasuringPointOverview
   */
  eventType?: MeasuringPointOverviewEventTypeEnum | null;
  /**
   *
   * @type {string}
   * @memberof MeasuringPointOverview
   */
  gmwBroId: string;
  /**
   *
   * @type {string}
   * @memberof MeasuringPointOverview
   */
  tubeNumber: string;
  /**
   *
   * @type {Date}
   * @memberof MeasuringPointOverview
   */
  tubeStartDate?: Date | null;
  /**
   *
   * @type {Date}
   * @memberof MeasuringPointOverview
   */
  tubeEndDate?: Date | null;
}

/**
 * @export
 */
export const MeasuringPointOverviewEventTypeEnum = {
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnTubeReference: "GMN_TubeReference",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnStartRegistration: "GMN_StartRegistration",
} as const;
export type MeasuringPointOverviewEventTypeEnum =
  (typeof MeasuringPointOverviewEventTypeEnum)[keyof typeof MeasuringPointOverviewEventTypeEnum];

/**
 * Check if a given object implements the MeasuringPointOverview interface.
 */
export function instanceOfMeasuringPointOverview(value: object): value is MeasuringPointOverview {
  if (
    (!("gmwBroId" in (value as Record<string, any>)) &&
      !("gmw_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["gmwBroId"] === undefined &&
      (value as Record<string, any>)["gmw_bro_id"] === undefined)
  )
    return false;
  if (
    (!("tubeNumber" in (value as Record<string, any>)) &&
      !("tube_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeNumber"] === undefined &&
      (value as Record<string, any>)["tube_number"] === undefined)
  )
    return false;
  return true;
}

export function MeasuringPointOverviewFromJSON(json: any): MeasuringPointOverview {
  return MeasuringPointOverviewFromJSONTyped(json, false);
}

export function MeasuringPointOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MeasuringPointOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    eventType:
      json["event_type"] === undefined
        ? undefined
        : json["event_type"] === null
        ? null
        : json["event_type"],
    gmwBroId: json["gmw_bro_id"],
    tubeNumber: json["tube_number"],
    tubeStartDate:
      json["tube_start_date"] === undefined
        ? undefined
        : json["tube_start_date"] === null
        ? null
        : new Date(json["tube_start_date"]),
    tubeEndDate:
      json["tube_end_date"] === undefined
        ? undefined
        : json["tube_end_date"] === null
        ? null
        : new Date(json["tube_end_date"]),
  };
}

export function MeasuringPointOverviewToJSON(json: any): MeasuringPointOverview {
  return MeasuringPointOverviewToJSONTyped(json, false);
}

export function MeasuringPointOverviewToJSONTyped(
  value?: Omit<MeasuringPointOverview, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    event_type: value["eventType"],
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    tube_start_date:
      value["tubeStartDate"] == null
        ? value["tubeStartDate"]
        : value["tubeStartDate"].toISOString().substring(0, 10),
    tube_end_date:
      value["tubeEndDate"] == null
        ? value["tubeEndDate"]
        : value["tubeEndDate"].toISOString().substring(0, 10),
  };
}
